import { getDictPhrase } from "../../../common";
export const getBetTitleTeaserBetProps = (bet, state) => {
    return {
        name: getDictPhrase(state.dict, bet.type.replace(".", "_")),
        odds: bet.displayOdds
    };
};
//# sourceMappingURL=getBetTitleTeaserBetProps.js.map